import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { RootState } from '../store';
import axios from '../utils/APIUtils';
import { DASHBOARD_API_PATHS } from '../constants/constants';
import IGetFilterAPIDetailsModal from '../models/IOverviewModel';
import { IFilterOverviewItemModel, IOverviewTypeModel, ITrendsYearValuesModel } from '../models/IOverviewModel';
import { GenericState } from './ISliceInterfaces';
import {DATE_FILTER_RANGE} from 'src/constants/constants';

export const initialState = {
  filters: [],
  overviewData: { status: 'idle' } as GenericState<any>,
  filterListAPIData: { status: 'idle' } as GenericState<IGetFilterAPIDetailsModal>,
  overviewViewType: { viewType: '' } as IOverviewTypeModel,
  filterOverview: [{ column: 'created_on', value: [`${new Date(new Date().setDate((new Date()).getDate() - DATE_FILTER_RANGE.ONE_YEAR)).toISOString().slice(0, 10)}`, `${new Date().toISOString().slice(0, 10)}`], type: "in" }] as IFilterOverviewItemModel[],
  trendsYearRange: [],
  trendsYearValues: [] as ITrendsYearValuesModel[],
  selectedDomainValue: 'All',
  countryOptionRx: [],
  fromDate: `${new Date(new Date().setDate((new Date()).getDate() - DATE_FILTER_RANGE.ONE_YEAR)).toISOString().slice(0, 10)}`,
  toDate: `${new Date().toISOString().slice(0, 10)}`,
  riskData: { title: "" },
  riskType: "",
  applyRefresh: false,
  overviewReduxLocalFilters: {}
};

export const getFilterListData = createAsyncThunk('overview/getFilterListData', async (arg, thunkAPI) => {
  const store: any = thunkAPI.getState();
  const currentRole : string =store.onBoarding.currentRole;
  const params = {"current_role": currentRole}
  const response = await axios.get<IGetFilterAPIDetailsModal>(DASHBOARD_API_PATHS.filterList,{params});
  return response.data;
});


export const postFilter = createAsyncThunk('overview/postfilter', async (data: any) => {
  const response = await axios.post<any>(DASHBOARD_API_PATHS.dashboardfilter, data);
  return response.data;
});


export const overviewSlice = createSlice({
  name: 'overview',
  initialState,
  reducers: {
    updateFilterValue: (state, action) => {
      state.filters = action.payload;
    },
    addFilterOverview: (state, action) => {
      state.filterOverview = action.payload;
    },
    clearAllFilters: (state, action) => {
      state.filterOverview = [];
    },

    updateFromDate: (state, action) => {
      state.fromDate = action.payload;
    },
    updateToDate: (state, action) => {
      state.toDate = action.payload;
    },
    setOverviewViewType: (state, action) => {
      state.overviewViewType.viewType = action.payload;
    },
    setTrendsYearRange: (state, action) => {
      state.trendsYearRange = action.payload;
    },
    setCountryOptionRx: (state, action) => {
      state.countryOptionRx = action.payload;
    },
    setOverviewViewRisk: (state, action) => {
      state.riskData = action.payload;
    },
    setCurrentRisk: (state, action) => {
      state.riskType = action.payload;
    },
    setTrendsYear: (state, action) => {
      state.trendsYearRange = action.payload;
    },
    setTrendsYearValues: (state, action) => {
      state.trendsYearValues = action.payload;
    },
    setSelectedDomainValue: (state, action) => {
      state.selectedDomainValue = action.payload;
    },
    setApplyRefresh: (state, action) => {
      state.applyRefresh = action.payload;
    },
    setOverviewLocalFilters: (state, action) => {
      state.overviewReduxLocalFilters = action.payload;
    },
  },
  extraReducers: builder => {
    builder.addCase(getFilterListData.pending, (state) => {
      state.filterListAPIData.status = 'loading';
    });
    builder.addCase(getFilterListData.fulfilled, (state, action) => {
      state.filterListAPIData.status = 'finished';
      state.filterListAPIData.data = action.payload;
    });
    builder.addCase(getFilterListData.rejected, (state) => {
      state.filterListAPIData.status = 'error';
    });
    builder.addCase(postFilter.pending, (state) => {
      state.overviewData.status = 'loading';
    });
    builder.addCase(postFilter.fulfilled, (state, action) => {
      state.overviewData.status = 'finished';
      state.overviewData.data = action.payload;
    });
    builder.addCase(postFilter.rejected, (state) => {
      state.overviewData.status = 'error';
    });
  }
});

export const { updateFilterValue } = overviewSlice.actions;
export const { addFilterOverview, 
  updateFromDate, 
  updateToDate, 
  setOverviewViewType, 
  setOverviewViewRisk, 
  setCurrentRisk, 
  setTrendsYearRange, 
  setTrendsYearValues, 
  setSelectedDomainValue, 
  setApplyRefresh, 
  setCountryOptionRx,
  setOverviewLocalFilters } = overviewSlice.actions;
export const getFilterOverViewSelector = (state: RootState) => state.overview.filterOverview;
export const getFilterListAPIData = (state: RootState) => state.overview.filterListAPIData;
export const getFromDate = (state: RootState) => state.overview.fromDate;
export const getToDate = (state: RootState) => state.overview.toDate;
export const getOverviewViewType = (state: RootState) => state.overview.overviewViewType.viewType;
export const getRiskData = (state: RootState) => state.overview.riskData;
export const getRiskType = (state: RootState) => state.overview.riskType;
export const getTrendsYearValues = (state: RootState) => state.overview.trendsYearValues;
export const getTrendsYearRange = (state: RootState) => state.overview.trendsYearRange;
export const getSelectedDomainValue = (state: RootState) => state.overview.selectedDomainValue;
export const getApplyRefresh = (state: RootState) => state.overview.applyRefresh;
export const getOverviewLocalFilters = (state: RootState) => state.overview.overviewReduxLocalFilters

export default overviewSlice.reducer;